import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const [state, setState] = useState({ status: "checking" });

  useEffect(() => {
    const sid = params.get("session_id");
    let tries = 0;
    let t;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setState({ status: "paid", kind: data.kind }); refresh(); return; }
        if (data.status === "expired") { setState({ status: "failed" }); return; }
      } catch { /* transient network error: the next poll retries */ }
      if (++tries < 15) t = setTimeout(poll, 2000);
      else setState({ status: "timeout" });
    };
    poll();
    return () => clearTimeout(t);
  }, [params, refresh]);

  return (
    <main className="max-w-lg mx-auto px-4 py-20 text-center" data-testid="payment-success-page">
      {state.status === "checking" && <><Loader2 className="h-12 w-12 mx-auto animate-spin text-[#FF5A79]" /><p className="mt-4 font-display text-2xl">Confirming your payment...</p></>}
      {state.status === "paid" && (
        <>
          <CheckCircle2 className="h-16 w-16 mx-auto text-[#36D399]" />
          <h1 className="mt-4 text-4xl font-bold" data-testid="payment-success-title">{state.kind === "merch" ? "Order placed!" : "Credits added!"}</h1>
          <p className="mt-2 text-[#6E687A]">{state.kind === "merch" ? "Your product is headed to the printer." : "Time to make more masterpieces."}</p>
          <Link to={state.kind === "merch" ? "/gallery" : "/studio"} className="mt-8 inline-block rounded-full bg-[#FF5A79] text-white px-7 py-3 font-bold sticker sticker-press" data-testid="payment-success-continue">Continue</Link>
        </>
      )}
      {(state.status === "failed" || state.status === "timeout") && (
        <><XCircle className="h-14 w-14 mx-auto text-red-500" /><p className="mt-4 font-display text-2xl" data-testid="payment-failed-title">We couldn't confirm that payment.</p>
          <Link to="/credits" className="mt-6 inline-block font-bold text-[#FF5A79]">Back to credits</Link></>
      )}
    </main>
  );
}
